const localCategoryImages = {
  Water: '/images/boattour.webp',
  Cultural: '/images/bigbus.webp',
  Adventure: '/images/airboat.webp',
  Food: '/images/bigbus.webp',
  Nightlife: '/images/bigbus.webp',
};

const responsiveImageVariants = {
  '/images/private-transport-van.webp': {
    originalWidth: 1800,
    card: {
      src: '/images/private-transport-van-card.webp',
      width: 640,
    },
  },
  '/images/city-boat-combo.webp': {
    originalWidth: 1600,
    card: {
      src: '/images/city-boat-combo-card.webp',
      width: 760,
    },
  },
  '/images/miami-yacht-rental.webp': {
    originalWidth: 1110,
    card: {
      src: '/images/miami-yacht-rental-card.webp',
      width: 760,
    },
  },
  '/images/biscayne-party-boat.webp': {
    originalWidth: 1103,
    card: {
      src: '/images/biscayne-party-boat-card.webp',
      width: 760,
    },
  },
  '/images/bigbus.webp': {
    originalWidth: 1400,
    card: {
      src: '/images/bigbus-card.webp',
      width: 760,
    },
  },
  '/images/airboat.webp': {
    originalWidth: 1800,
    card: {
      src: '/images/airboat-card.webp',
      width: 760,
    },
  },
  '/images/mustang-convertible.webp': {
    originalWidth: 640,
    card: {
      src: '/images/mustang-convertible-card.webp',
      width: 544,
    },
  },
  '/images/miami-jet-ski.webp': {
    originalWidth: 900,
    card: {
      src: '/images/miami-jet-ski-card.webp',
      width: 640,
    },
  },
};

export function getTourFallbackImage(tour) {
  if (!tour) {
    return localCategoryImages.Water;
  }

  return localCategoryImages[tour.category] || localCategoryImages.Water;
}

export function getTourImage(tour) {
  return tour?.image || getTourFallbackImage(tour);
}

export function getResponsiveImageProps(src, variant = 'card') {
  const source = String(src || '');
  const variantConfig = responsiveImageVariants[source]?.[variant];
  const originalWidth = responsiveImageVariants[source]?.originalWidth;

  if (!variantConfig || !originalWidth) {
    return {};
  }

  return {
    src: variantConfig.src,
    srcSet: `${variantConfig.src} ${variantConfig.width}w, ${source} ${originalWidth}w`,
  };
}

export function getTourCardImageProps(tour) {
  return getResponsiveImageProps(getTourImage(tour), 'card');
}

export const heroSlides = [
  {
    url: '/images/boattour.webp',
    label: 'Sunset Cruises',
    href: '/tours/bayside-boat-tour',
  },
  {
    url: '/images/keywest-southernmost.webp',
    label: 'Key West Day Trips',
    href: '/tours/key-west-island-escape',
  },
  {
    url: '/images/airboat.webp',
    label: 'Everglades Airboat Tours',
    href: '/tours/everglades-airboat-adventure',
  },
  {
    url: '/images/bigbus.webp',
    label: 'City Sightseeing',
    href: '/tours/miami-city-tour',
  },
  {
    url: '/images/boattour.webp',
    label: 'Biscayne Bay Excursions',
    href: '/tours/biscayne-bay-party-boat',
  },
];
